/* General styles */
.t-panes {
  @apply grid overflow-hidden;
  grid-template-columns: repeat(1, minmax(max-content, 1fr));
  grid-template-rows: repeat(1, minmax(0, 1fr));

  &.t-panes--transitioning {
    // Highlighting/focusing a row must not scroll this viewport sideways and
    // cancel the slide. Pane bodies still handle scrolling their own contents.
    @apply min-h-0 overflow-clip;
  }

  &.t-panes-max-w-full {
    grid-template-columns: 1fr;
    /* Pushed panes (e.g. the inline-create form) size their max-width from this var, defaulting to 400px
       when not inside a dropdown. In full-width mode, let them fill the container instead. */
    --dropdown-content-min-width: 100%;
    .t-pane {
      @apply min-w-0;
    }
  }
}
.t-pane {
  @apply row-start-1 col-start-1 transform transition-all duration-300;
}

/*
  Transform panes:
   Panes before the active pane are translated to the left
   Panes after the active pane are translated to the right
   The active pane is not translated (--tw-translate-x: 0)

  "Last pane" is expressed as `:not(:has(~ .t-pane))` rather than `:last-child` so a
  trailing non-pane sibling (a portalled template, a popper) can't make the whole
  stack think it has no last pane.
*/
.t-pane {
  --tw-translate-x: calc(-1 * var(--pane-width, 100%));
}
.t-pane--active,
.t-panes:not(.t-panes--transitioning) > .t-pane:not(:has(~ .t-pane)) {
  --tw-translate-x: 0;
}
.t-pane--active ~ .t-pane {
  --tw-translate-x: var(--pane-width, 100%);
}

.t-pane {
  @apply flex flex-col;
}
.t-pane__header {
  @apply bg-bg-base border-b border-border-base flex items-center;
  .t-pane__back.t-btn-link-gray {
    @apply opacity-50 hover:opacity-75;
  }
  .t-pane__heading {
    @apply ml-4 text-neutral-600 font-semibold;
  }
}
.t-pane__body {
  @apply overflow-auto flex-1;
}

/* No header (with back button) on the first pane */
.t-pane:first-child > .t-pane__header {
  @apply hidden;
}

/* Let the active pane determine the height, but keep outgoing contents visible
   throughout the slide. A zero intrinsic height avoids sizing the grid track;
   the percentage minimum then fills that track. */
.t-pane:not(.t-pane--active):has(~ .t-pane) {
  @apply h-0 min-h-full pointer-events-none;
}

/*
  When we are not transitioning (set by JS) the last pane IS the top of the stack —
  push appends it, and pop/replace/set/popToRoot all remove the panes above it before
  they clear the transitioning flag. So visibility is derived from position alone:
  exactly one pane shows, no matter where the `t-pane--active` marker sits.

  (It used to show `.t-pane--active` OR the last pane. Those are two sources of truth
  for "which pane is on top", and any moment they disagreed — a slide that finalized
  against the wrong pane — painted both panes in the same grid cell, so e.g. a course's
  modules showed through the lessons list drilled in on top of it.)

  Transform is removed from the visible pane because it can contain position: fixed
  items, and a transformed ancestor breaks fixed positioning.
*/
.t-panes:not(.t-panes--transitioning) {
  > .t-pane:has(~ .t-pane) {
    @apply hidden;
  }
  > .t-pane:not(:has(~ .t-pane)) {
    @apply transform-none;
  }
}
